const context = 'revenues'

export const FETCH_REVENUES = `${context}/FETCH_REVENUES`
